import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import store from '@/store';

/**
 * 角色权限检查
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    var roles = store.getters && store.getters.roles;
    var permissionRoles = value;
    var hasPermission = roles.some(function (role) {
      return permissionRoles.includes(role);
    });
    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    console.error("need roles! Like v-permission=\"['admin','editor']\"");
    return false;
  }
}

/**
 * 获取当前客户编码
 */
export function getClientCode() {
  var _store$state$app$gran;
  return ((_store$state$app$gran = store.state.app.grant) === null || _store$state$app$gran === void 0 ? void 0 : _store$state$app$gran.code) || '';
}

/**
 * 检查当前客户是否在指定的客户列表中
 * @param {string|Array} clientCodes 客户编码或客户编码数组
 * @returns {boolean}
 * @example
 * isClient('caky') // 检查是否为caky客户
 * isClient(['caky', 'ahxdf']) // 检查是否为caky或ahxdf客户
 */
export function isClient(clientCodes) {
  var currentCode = getClientCode();
  if (Array.isArray(clientCodes)) {
    return clientCodes.includes(currentCode);
  }
  return currentCode === clientCodes;
}

/**
 * 检查当前客户是否不在指定的客户列表中
 * @param {string|Array} clientCodes 客户编码或客户编码数组
 * @returns {boolean}
 * @example
 * isNotClient('caky') // 检查是否不是caky客户
 * isNotClient(['caky', 'ahxdf']) // 检查是否不是caky和ahxdf客户
 */
export function isNotClient(clientCodes) {
  return !isClient(clientCodes);
}

/**
 * 常用的权限检查示例：
 *
 * 1. 表格列权限控制：
 *    { label: '实购数量', prop: 'num2', display: isNotClient(['caky']) }
 *
 * 2. 按钮权限控制：
 *    <el-button v-if="isNotClient(['caky', 'demo'])">特殊功能</el-button>
 *
 * 3. 菜单权限控制：
 *    <el-menu-item v-if="isClient(['admin', 'super'])">管理菜单</el-menu-item>
 *
 * 4. 功能模块权限：
 *    <div v-if="isNotClient(['restricted'])">高级功能</div>
 */